import { ComponentProps } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

type MuiIconProps = ComponentProps<typeof SvgIcon>;

export const DecorateIcon = (props: MuiIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M7.8,4.1c0-.2.3-.2.4,0l.9,2.7c0,0,0,.1.1.1l2.7.9c.2,0,.2.3,0,.4l-2.7.9c0,0-.1,0-.1.1l-.9,2.7c0,.2-.3.2-.4,0l-.9-2.7c0,0,0-.1-.1-.1l-2.7-.9c-.2,0-.2-.3,0-.4l2.7-.9c0,0,.1,0,.1-.1l.9-2.7Z" />
      <path d="M2.3,2.3C5.5-.8,10.5-.8,13.7,2.3c2.1,2.1,2.8,5.1,2,7.8l-5.5,5.5c-2.6.7-5.5.1-7.6-1.9l-.2-.2C-.8,10.5-.8,5.5,2.3,2.3ZM12.2,3.8c-2.3-2.3-6.1-2.3-8.5,0-2.3,2.3-2.3,6.1,0,8.5,1.5,1.5,3.5,2,5.4,1.6.2-2.6,2.2-4.6,4.8-4.8.4-1.9-.2-3.9-1.6-5.4Z" />
    </SvgIcon>
  );
};
